import { AppConstants } from '@ltvco/refresh-lib/ctx';
import { SideNavigation } from '@ltvco/refresh-lib/v1';
import { useContext } from 'react';
import { useLocation } from 'react-router-dom';

export function Sidenav({ onReport }: { onReport?: boolean }) {
  const {
    config: { sideMenuItems },
  } = useContext(AppConstants);
  const location = useLocation();
  return (
    <SideNavigation
      menuItems={sideMenuItems}
      matchingRoute={location.pathname}
      onReport={onReport}
      hideItems={[
        { name: 'myGarage', routesToHide: ['dashboard', 'report'] },
        { name: 'myAccount', routesToHide: ['report'] },
      ]}
    />
  );
}
